// Offcanvas does not automatically update the aria-expanded attribute on the toggle button

const events = {
  handleEvent: ({ target, type }) => {
    const button = document.querySelector(`[data-bs-target="#${target.id}"]`);
    button.ariaExpanded = type === 'show.bs.offcanvas';
  }
}

document.addEventListener('show.bs.offcanvas', events);
document.addEventListener('hide.bs.offcanvas', events);
